export const APP_NAME = 'MyBrac';
export const PERSIST_STORE_NAME = 'MyBrac-admin';
